import loader from './loader.json';

export const animations = {
	loader,
};
